import { render, staticRenderFns } from "./CustomerLastName.vue?vue&type=template&id=72df9686&"
import script from "./CustomerLastName.vue?vue&type=script&lang=ts&"
export * from "./CustomerLastName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports